import React from "react"
import SelectQuantity from "../../components/SelectQuantity"
import moment from "moment-timezone"

import "./styles.css"

// Set default timezone
moment.tz.setDefault("America/New_York")

const Details = ({
  appointment,
  themeColor,
  updateQuantity,
  handleSetView,
  addToCart,
  selectedEvent,
}) => {
  const {
    title = "",
    descriptionHtml = "",
    image = "",
    price = "",
    quantity,
    spotsRemaining,
  } = appointment

  return (
    <div className="ct-modal__details">
      <div className="ct-modal__details--image">
        <img src={image} alt={title} />
      </div>
      <div className="ct-modal__details--content">
        {selectedEvent.start && (
          <span className="ct-modal__details--time">
            <span className="ct-modal__details--time__title">
              Selected Time:
            </span>{" "}
            {moment(selectedEvent.start).format(`MMM DD, YYYY \\at h:mm a`)}
          </span>
        )}
        <div className="ct-modal__details--heading--container">
          <div>
            <span className="ct-modal__details--heading">{title}</span>
            {spotsRemaining && (
              <span className="ct-modal__details--remaining">
                Spots remaining: {spotsRemaining}
              </span>
            )}
          </div>
          <span className="ct-modal__details--price">
            ${(price * quantity).toFixed(2)}
          </span>
        </div>
        {/* <span className="ct-modal__details--subheading">Duration: {duration}</span> */}
        <div
          className="ct-modal__details--preview"
          dangerouslySetInnerHTML={{ __html: descriptionHtml }}
        />
      </div>
    </div>
  )
}

export default Details
